import { CommonModule } from '@angular/common';
import { Component, effect, inject, signal } from '@angular/core';
import { Project, Result } from '../../../../core/models/projects.interface';
import { ProjectsService } from '../../../../core/services/Projects/projects.service';
import { LanguageService } from '../../../../core/services/Language/lang.service';
import { InvestmentFlowService } from '../../../../core/services/Investment-flow/investment-flow.service';
import { ProjectCardComponent } from '../../../../shared/components/project-card/project-card.component';

@Component({
  selector: 'app-projects-grid',
  standalone: true,
  imports: [CommonModule, ProjectCardComponent],
  templateUrl: './projects-grid.component.html',
  styleUrl: './projects-grid.component.css',
})
export class ProjectsGridComponent {
  private readonly projectsService = inject(ProjectsService);
  public readonly languageService = inject(LanguageService);
  public readonly flow = inject(InvestmentFlowService);

  projects = signal<Result[]>([]);
  total = 0;

  private lastLang: 'ar' | 'en' | null = null;

  constructor() {
    effect(() => {
      const lang = this.languageService.lang();

      if (this.lastLang === lang) return;
      this.lastLang = lang;

      this.loadProjects();
    });
  }

  loadProjects(): void {
    this.projectsService.getProjects().subscribe({
      next: (res: Project) => {
        this.projects.set(res.results || []);
        this.total = res.count || 0;
      },
      error: (err) => {
        console.error(err);
        this.projects.set([]);
        this.total = 0;
      }
    });
  }

  onInvest(project: Result): void {
    this.flow.openStart();
  }
}